import React, {Component} from 'react';
import Jumbo from '../../components/Jumbo/Jumbo';
import {Container, Row, Col, Button, Form, FormGroup, Label, Input, Badge} from 'reactstrap';
import Map from '../../components/Map/Map';
import cover from '../../assets/images/contact/IMG_1065.jpg';
import {NavLink} from 'react-router-dom';

class ContactUs extends Component {


    render(){
        return(
            <div className='contact-us-page' id="contact-us">
                <Jumbo title='Kontakt oss' content='Om du lurer på noe så ta gjerne kontakt med oss. Vi svarer gjerne på spørsmål, gir deg informasjon eller inviterer deg ned på et besøk på Ungdomssamfundet' button="false" image={cover} />
                <Container>
                    <Row className="contact-us-page-form">
                        <Col xs='12' md='6'>
                            <h2>Ta kontakt med oss i dag</h2>
                            <p>Vi svarer gjerne på dine spørsmål om du har noen. Ta kontakt via e-post eller kom innom oss i vår åpningstid.</p>
                            <p>Vi har åpent på Ungdomssamfundet 3 dager i uken (mandag, onsdag og torsdag). Du er velkommen til å komme innom oss for å se på lokalet i forbindelse med bursdagsfeiring eller komme innom oss om du ønsker å samarbeide med oss. Se vår kalender for åpningstider.</p>
                            <p className="contact-us-note-security"><Badge color="warning">Merk</Badge> Av sikkerhetsmessige årsaker må alle over 20 år identifisere seg og gi en grunn for besøket for å bli tillatt inn.</p>
                        </Col>
                        <Col xs='12' md='6'>
                            <p><i>Merk: </i>Vi leier ikke lenger ut vårt lokale til bursdagsfeiringer. Dette av hensyn til ressurser og da det dessverre har forsvunnet ting fra vårt lokale under utleie.</p>
                            <Form action="https://formspree.io/michael@extragiverglede.no" method="POST">
                                <FormGroup>
                                    <Label for="name">Fullt navn</Label>
                                    <Input type="text" name="fullname" id="name" placeholder="Ditt navn" />
                                </FormGroup>
                                <FormGroup>
                                    <Label for="email">E-post</Label>
                                    <Input type="email" name="email" id="email" placeholder="E-post adresse"/>
                                </FormGroup>
                                <FormGroup>
                                    <Label for="phone">Telefonnummer</Label>
                                    <Input type="text" name="phone" id="phone" placeholder="Telefonnummer" />
                                </FormGroup>
                                <FormGroup>
                                    <Label for="message">Melding</Label>
                                    <Input type="textarea" name="message" id="message" placeholder="Skriv din melding her" />
                                </FormGroup>
                                <Button>Send inn</Button>
                            </Form>
                        </Col>
                    </Row>
                    <Row className="contact-us-page-visit-us">
                        <Col>
                            <h1>Besøk oss</h1>
                            <p>Besøk oss gjerne. Våre åpningstider finner du a <NavLink to='/apningstider'>her.</NavLink> </p>
                            <Map  isMarkerShown
                                  googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=AIzaSyCD4bEKxnOeNZM5tuF3AmWIQtnGWxxhvus"
                                  loadingElement={<div style={{ height: `100%` }} />}
                                  containerElement={<div style={{ height: `400px` }} />}
                                  mapElement={<div style={{ height: `100%` }} />}
                            />
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    }
}

export default ContactUs;



// WEBPACK FOOTER //
// ./src/containers/ContactUs/ContactUs.js